"use strict";

exports.__esModule = true;
exports.default = exports.StyledCol = void 0;

var _stitches = require("../theme/stitches.config");

const StyledCol = (0, _stitches.styled)('div', {
  float: 'left',
  boxSizing: 'border-box',
  pl: 'calc($$rowGap / 2)',
  pr: 'calc($$rowGap / 2)'
});
exports.StyledCol = StyledCol;
var _default = StyledCol;
exports.default = _default;